<div class="plantilla overflow-hidden d-flex flex-column align-items-center">
  <div class="contenedorCard" [ngClass]="clase">
    <p class="tarjeta" >{{nombreCard}}</p>
    <img [src]="source" height="230.5" width="370"/>
  </div>
</div>
